import { Textbox } from 'fabric';

/**
 * Preserves existing styles and applies the last character style to any text
 * appended beyond the original content.
 */
export function setTextPreservingStyles(text: Textbox, newText: string): void {
  const oldText = text.text ?? '';
  if (oldText === newText) return;

  let trailingStyle: object | undefined;
  if (oldText.length > 0 && newText.length > oldText.length) {
    const lastIdx = oldText.length - 1;
    const [style] = text.getSelectionStyles(lastIdx, lastIdx + 1);
    if (style && Object.keys(style).length > 0) trailingStyle = style;
  }

  text.set('text', newText);

  if (trailingStyle) {
    text.setSelectionStyles(trailingStyle, oldText.length, newText.length);
  }
}
